<ngx-spinner size="medium"
  ><p>{{ messageKey | translate }}...</p></ngx-spinner
>
